import React from "react";
import { Helmet } from "react-helmet";

function Canteen() {
  return (
		<>
			<Helmet>
				<title>VBU - Cafeteria</title>
			</Helmet>
			<div className="PageContainer">
				<div className="Campus">
					<div id="Heading">
						<h1>Campus Cafeteria</h1>
					</div>

					<div className="Desc">
						<div className="DescParagraph" style={{ width: '100%' }}>
							<p>
								The university campus cafeteria is a vibrant, comfortable, and welcoming place where students,
								faculty, and staff can gather to eat, relax, and socialize. Located strategically in a central area of the campus, it is open throughout the day, providing a much-needed revitalizing break from rigorous academic schedules and laboratory sessions.
								<br />
								<br />
								Our cafeteria prides itself on maintaining high standards of hygiene and offers a wide, diverse menu to cater to different tastes. The available offerings range from hot, traditional Indian meals and robust thalis to quick wholesome snacks, cold sandwiches, and an assortment of healthy beverages. Particular attention is given to the nutritional value and affordability of the food provided to ensure it meets the requirements of the student community.
								<br />
								<br />
								Beyond just a dining facility, the cafeteria serves as a primary social hub on campus. It is a highly popular and lively spot for students to meet up with friends, engage in informal academic discussions, collaborate on project ideas, and foster invaluable peer networking in a relaxed, open environment.
							</p>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Canteen;
